import React from 'react'
import { Form, Formik, FormikErrors, FormikProps, getIn } from 'formik'

import {
  Contract,
  ContractTenant,
  ModifyContractInput,
  UserMetadata,
} from '../../../../../common/validations'
import { ModificationPreview } from '../ModificationPreview'
import { ModificationContractSuccess } from '../ModificationSuccess'
import { ContractChangesViewState } from '../../types'

type ModificationFormLayoutProps = {
  view: ContractChangesViewState
  setView: (view: ContractChangesViewState) => void
  contract: Contract
  tenants: ContractTenant[]
  userMetadata: UserMetadata
  initialValues: ModifyContractInput
  validate: (values: ModifyContractInput) => FormikErrors<ModifyContractInput>
  children: (
    form: FormikProps<ModifyContractInput>,
    genericError: string | undefined
  ) => React.ReactNode
}

export const ModificationFormLayout: React.FC<ModificationFormLayoutProps> = ({
  view,
  setView,
  contract,
  tenants,
  userMetadata,
  initialValues,
  validate,
  children,
}) => (
  <Formik initialValues={initialValues} onSubmit={() => {}} validate={validate}>
    {(form: FormikProps<ModifyContractInput>) => {
      const genericError: string | undefined = getIn(
        form.errors,
        'genericError'
      )

      return (
        <>
          {view === 'success' && <ModificationContractSuccess />}
          {view === 'preview' && (
            <ModificationPreview
              cancel={() => setView('form')}
              contract={contract}
              tenants={tenants}
              formValues={form.values}
              userMetadata={userMetadata}
            />
          )}
          {view === 'form' && <Form>{children(form, genericError)}</Form>}
        </>
      )
    }}
  </Formik>
)
